import React, { useMemo } from 'react';
import { Clock } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { getOpenStatus, openStatusLabel } from '@/lib/openingHours';

const COLORS = {
  open: 'text-emerald-600',
  open24: 'text-emerald-600',
  soon: 'text-amber-600',
  closed: 'text-red-500',
};

export const OpenStatusBadge = ({ openingHours, size = 'sm', placeId }) => {
  const { language } = useLanguage();
  const status = useMemo(() => getOpenStatus(openingHours), [openingHours]);
  const label = openStatusLabel(status, language);
  if (!label) return null;
  const tone = status.state === 'closed' ? 'closed' : status.closingSoon ? 'soon' : 'open';
  const textCls = size === 'lg' ? 'text-sm' : 'text-xs';

  return (
    <div className={`flex items-center gap-1 ${textCls}`} data-testid={`open-status-${placeId || 'badge'}`}>
      <Clock size={size === 'lg' ? 14 : 11} className={COLORS[tone]} />
      <span className={`font-semibold ${COLORS[tone]}`}>{label.main}</span>
      {label.detail && <span className="text-gray-500">· {label.detail}</span>}
    </div>
  );
};

export default OpenStatusBadge;
